import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { editBookingRulesName } from '../lib/booking-rules';
import { bookingRulesKeys } from '../query-keys/booking-rules';

export const useEditBookingRulesName = (onSuccess?: () => void) => {
  const { t } = useTranslation(['bookingRules', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ token, name }: { token: string; name: string }) =>
      editBookingRulesName(token, name),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: bookingRulesKeys.lists(),
        });
      });
      toast.success(
        t('bookingRules:common.editBookingRulesNameDialog.success'),
      );
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
